import { useState, ReactNode } from "react";

// ui
import {
  Button,
  Box,
  Checkbox,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { PoModalShell } from "../common/PoModalShell";
import { PoButton } from "../common/PoButton";
import { PoTextField, PoHelper, PoField, PoLabel, PoSelect, PoCheckRow, PoCheckbox } from "../common/PoForm";

// InterFace
import { LIST_POST } from "../../config/const";

// jotai
import { useAtomValue } from "jotai";
import { AppAtoms } from "../../lib/store";
// ★cmd-po_1221 R9: 編集成功をトースト→結果モーダルへ統一
import { DataAddModalResult } from "../DataAddModalResult";

function SerchTextField({
  width,
  label,
  helperText,
  value,
  setValue,
  dataKey,
  addData,
  multiline,
  rows,
  testId,
  fieldKey,
  required,
}: {
  width: string;
  label: ReactNode;
  helperText: string;
  value: string;
  setValue: (value: string) => void;
  dataKey: string;
  addData: { [key: string]: string | boolean | any[] };
  multiline?: boolean;
  rows?: number;
  testId?: string;
  fieldKey?: string;
  required?: boolean;
}) {
  const inputEl = (
    <PoTextField
      disabled={
        dataKey === "sns_id" &&
        (Number(addData["sns_type"]) == 2 || Number(addData["sns_type"]) == 3)
          ? true
          : false
      }
      type={dataKey !== "password" ? "text" : "password"}
      value={value}
      size="small"
      multiline={multiline}
      rows={rows}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value)}
      sx={{ width: testId ? "100%" : width, ...(testId ? {} : { margin: "10px 5px" }), ...(multiline ? { "& .MuiInputBase-input": { height: "auto" } } : {}) }}
    />
  );
  if (testId) {
    return (
      <PoField fieldKey={fieldKey ?? ""} testId={testId}>
        <PoLabel required={required}>{label}</PoLabel>
        {inputEl}
        {helperText ? <PoHelper>{helperText}</PoHelper> : null}
      </PoField>
    );
  }
  return (
    <Box>
      <Box sx={{ fontSize: 12, fontWeight: 600, color: "var(--color-sumi, #374151)", display: "flex", alignItems: "center", gap: "var(--sp-2, 8px)" }}>{label}</Box>
      {inputEl}
      {helperText ? (
        <PoHelper sx={{ width, textAlign: "right", marginTop: "-8px", height: "25px", fontSize: 11 }}>
          {helperText}
        </PoHelper>
      ) : null}
    </Box>
  );
}

interface InputProductOptionProps {
  selectOption: {
    option_name: string;
    outside_form_display: 0 | 1;
    sns_send: 0 | 1;
    required_optional: 0 | 1;
    option_type: 0 | 1 | 2 | 3 | 4;
    option_default_value: string;
    change_value_conf: 0 | 1;
    option_comment: string;
    tel_flg: 0 | 1;
    name_flg: 0 | 1;
    company_name_flg: 0 | 1;
    zip_code_flg: 0 | 1;
    address_flg: 0 | 1;
    space_flg: 0 | 1;
    mail_address_flg: 0 | 1;
    form_tel_flg: 0 | 1;
    multi_text_flg: 0 | 1;
    contract_number_flg: 0 | 1;
    half_width_number_flg: 0 | 1;
    option_select: string[];
  };
  setEelectOption: (select_option: {
    option_name: string;
    outside_form_display: 0 | 1;
    sns_send: 0 | 1;
    required_optional: 0 | 1;
    option_type: 0 | 1 | 2 | 3 | 4;
    option_default_value: string;
    change_value_conf: 0 | 1;
    option_comment: string;
    tel_flg: 0 | 1;
    name_flg: 0 | 1;
    company_name_flg: 0 | 1;
    zip_code_flg: 0 | 1;
    address_flg: 0 | 1;
    space_flg: 0 | 1;
    mail_address_flg: 0 | 1;
    form_tel_flg: 0 | 1;
    multi_text_flg: 0 | 1;
    contract_number_flg: 0 | 1;
    half_width_number_flg: 0 | 1;
    option_select: string[];
  }) => void;
  formType?: "entry_form" | "toss_up_form" | "outside_entry_form";
}
function InputProductOption(props: InputProductOptionProps) {
  const { selectOption, setEelectOption, formType } = props;

  const pathname = useAtomValue(AppAtoms.pathname);
  const resolvedFormType = formType ?? (pathname === "/entry_form" ? "entry_form" : pathname === "/toss_up_form" ? "toss_up_form" : pathname === "/outside_entry_form" ? "outside_entry_form" : null);
  const [selectNameList, setSelectNameList] = useState<string[]>([]);
  return (
    <>
      <SerchTextField
        width="calc(100% - 10px)"
        label="質問名"
        helperText={""}
        value={selectOption["option_name"]}
        setValue={(value) => {
          setEelectOption({
            ...selectOption,
            option_name: value,
          });
        }}
        dataKey={""}
        addData={{}}
        testId="form-options-edit-field-option_name"
        fieldKey="option_name"
        required={true}
      />
      <PoField testId="form-options-edit-field-option_type" fieldKey="option_type">
        <PoLabel required={true}>質問区分</PoLabel>
        <PoSelect
          labelId="serch-input-label"
          id="serch-input"
          value={selectOption["option_type"]}
          onChange={(e) => {
            setEelectOption({
              ...selectOption,
              option_type: Number(e.target.value) as 0 | 1 | 2 | 3 | 4,
              option_default_value: "",
              change_value_conf: 0,
              tel_flg: 0,
              name_flg: 0,
              company_name_flg: 0,
              zip_code_flg: 0,
              address_flg: 0,
              space_flg: 0,
              mail_address_flg: 0,
              form_tel_flg: 0,
              multi_text_flg: 0,
              contract_number_flg: 0,
              half_width_number_flg: 0,
              option_select: [""],
            });
          }}
          sx={{ height: 36, fontSize: 13, borderRadius: "var(--radius-sm, 6px)", textAlign: "end" }}
        >
          {LIST_POST["option_type"].map((input, i) => (
            <MenuItem key={"input" + i} value={input.id} sx={{ fontSize: "14px", height: input.value === "" ? "14px" : "24px" }}>
              {input.value}
            </MenuItem>
          ))}
        </PoSelect>
      </PoField>
      {selectOption["option_type"] === 0 ? (
        <PoField testId="form-options-edit-field-flg" fieldKey="flg">
          <PoLabel>フラグ設定</PoLabel>
          <PoSelect
              labelId="serch-input-label"
              id="serch-input"
              value={
                selectOption["tel_flg"] == 1
                  ? 1
                  : selectOption["name_flg"] == 1
                    ? 2
                    : selectOption["zip_code_flg"] == 1
                      ? 3
                      : selectOption["address_flg"] == 1
                        ? 4
                        : selectOption["space_flg"] == 1
                          ? 5
                          : selectOption["mail_address_flg"] == 1
                            ? 6
                            : selectOption["form_tel_flg"] == 1
                              ? 7
                              : selectOption["multi_text_flg"] == 1
                                ? 8
                                : selectOption["company_name_flg"] == 1
                                  ? 9
                                  : selectOption["contract_number_flg"] == 1
                                    ? 10
                                    : selectOption["half_width_number_flg"] == 1
                                      ? 11
                                      : 0
              }
              onChange={(e) => {
                if (Number(e.target.value) === 0) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 1) {
                  setEelectOption({
                    ...selectOption,
                    required_optional: 1,
                    outside_form_display: 0,
                    sns_send: 1,
                    tel_flg: 1,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 2) {
                  setEelectOption({
                    ...selectOption,
                    required_optional: 1,
                    outside_form_display: 0,
                    sns_send: 1,
                    tel_flg: 0,
                    name_flg: 1,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 3) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 1,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 4) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 1,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 5) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 1,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 6) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 1,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 7) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 1,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 8) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 1,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 9) {
                  setEelectOption({
                    ...selectOption,
                    required_optional: 1,
                    outside_form_display: 0,
                    sns_send: 1,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 1,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 10) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 1,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 11) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 1,
                  });
                }
              }}
              sx={{ height: 36, fontSize: 13, borderRadius: "var(--radius-sm, 6px)", textAlign: "end" }}
            >
              {resolvedFormType === "entry_form"
                ? (
                    LIST_POST["entry_form_option_flg"] as {
                      id: number;
                      value: string;
                    }[]
                  ).map((input, i) => (
                    <MenuItem
                      key={"input" + i}
                      value={input.id}
                      sx={{
                        fontSize: "14px",
                        height: input.value === "" ? "14px" : "24px",
                      }}
                    >
                      {input.value}
                    </MenuItem>
                  ))
                : resolvedFormType === "outside_entry_form"
                  ? LIST_POST["contract_option_flg"].map((input, i) => {
                      return (
                        <MenuItem
                          key={"input" + i}
                          value={input.id}
                          sx={{
                            fontSize: "14px",
                            height: input.value === "" ? "14px" : "24px",
                          }}
                        >
                          {input.value}
                        </MenuItem>
                      );
                    })
                  : resolvedFormType === "toss_up_form"
                    ? LIST_POST["toss_up_option_flg"].map((input, i) => {
                        return (
                          <MenuItem
                            key={"input" + i}
                            value={input.id}
                            sx={{
                              fontSize: "14px",
                              height: input.value === "" ? "14px" : "24px",
                            }}
                          >
                            {input.value}
                          </MenuItem>
                        );
                      })
                    : null}
          </PoSelect>
        </PoField>
      ) : selectOption["option_type"] === 1 ||
        selectOption["option_type"] === 2 ? (
        <Box data-testid="form-options-edit-dep-block" sx={{ borderLeft: "3px solid var(--color-kohaku, #d97706)", paddingLeft: "var(--sp-3, 12px)", display: "flex", flexDirection: "column", gap: "var(--sp-4, 16px)", marginTop: "calc(-1 * var(--sp-2, 8px))" }}>
          {selectOption.option_select.map(
            (option_select: string, select_i: number) => {
              return (
                <Box
                  key={"addBoxOptionSelect_" + select_i}
                  data-testid="form-options-edit-opt-row"
                  sx={{ display: "flex", alignItems: "center", gap: "var(--sp-2, 8px)", marginBottom: "var(--sp-2, 8px)" }}
                >
                  <SerchTextField
                    width="100%"
                    key={"serchColumnBubun" + select_i}
                    label={"選択肢 - " + (select_i + 1)}
                    helperText={""}
                    value={option_select}
                    setValue={(value) => {
                      let _option_select = selectOption.option_select.concat();
                      _option_select[select_i] = value;
                      setEelectOption({
                        ...selectOption,
                        option_select: _option_select,
                      });
                    }}
                    dataKey={""}
                    addData={{}}
                  />
                  {selectOption.option_select.length > 1 ? (
                    <Button
                      data-testid="form-options-edit-opt-remove"
                      sx={{ width: 26, height: 26, minWidth: 0, color: "var(--color-sumi-muted, #9ca3af)" }}
                      onClick={() => {
                        let _option_select = selectOption.option_select.concat();
                        _option_select = _option_select.filter(
                          (_product_option: string, _select_i: number) =>
                            select_i !== _select_i,
                        );
                        setEelectOption({
                          ...selectOption,
                          option_select: _option_select,
                        });
                      }}
                    >
                      <RemoveCircleOutlineIcon fontSize="small" />
                    </Button>
                  ) : null}
                </Box>
              );
            },
          )}
          <Box data-testid="form-options-edit-opt-add-row" sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              data-testid="form-options-edit-opt-add"
              onClick={() => {
                let _option_select = selectOption.option_select.concat();
                _option_select.push("");
                setEelectOption({
                  ...selectOption,
                  option_select: _option_select,
                });
              }}
            >
              <AddCircleOutlineIcon fontSize="medium" />
            </Button>
          </Box>
        </Box>
      ) : null}
      <PoField testId="form-options-edit-field-required_optional" fieldKey="required_optional">
        <PoLabel>必須フラグ</PoLabel>
        <PoCheckRow>
          <PoCheckbox
            checked={selectOption["required_optional"] === 1}
            onChange={() => {
              setEelectOption({
                ...selectOption,
                required_optional:
                  selectOption["required_optional"] === 1 ? 0 : 1,
              });
            }}
          />
          <span>必須項目とする場合はチェックしてください。</span>
        </PoCheckRow>
      </PoField>
      {resolvedFormType === "outside_entry_form" &&
      selectOption["tel_flg"] != 1 &&
      selectOption["name_flg"] != 1 &&
      selectOption["company_name_flg"] != 1 ? (
        <PoField testId="form-options-edit-field-outside_form_display" fieldKey="outside_form_display">
          <PoLabel>外部ETフォームでの表示</PoLabel>
          <PoSelect
            labelId="serch-input-label"
            id="serch-input"
            value={selectOption["outside_form_display"]}
            onChange={(e) => {
              setEelectOption({
                ...selectOption,
                outside_form_display: Number(e.target.value) as 0 | 1,
              });
            }}
            sx={{ height: 36, fontSize: 13, borderRadius: "var(--radius-sm, 6px)", textAlign: "end" }}
          >
            {LIST_POST["outside_form_display"].map((input, i) => (
              <MenuItem key={"input" + i} value={input.id} sx={{ fontSize: "14px", height: input.value === "" ? "14px" : "24px" }}>
                {input.value}
              </MenuItem>
            ))}
          </PoSelect>
          <PoHelper sx={{ textAlign: "right", fontSize: 11, color: "var(--color-sumi-muted, #9ca3af)" }}>
            ※外部ETフォームに表示するかどうかを選択できます
          </PoHelper>
        </PoField>
      ) : null}
      {selectOption["option_type"] == 0 ? (
        <SerchTextField
          width="calc(100% - 10px)"
          label={"デフォルト値"}
          helperText={""}
          value={selectOption["option_default_value"]}
          setValue={(value) => {
            if (value === "") {
              setEelectOption({
                ...selectOption,
                option_default_value: value,
                change_value_conf: 0,
              });
            } else {
              setEelectOption({
                ...selectOption,
                option_default_value: value,
              });
            }
          }}
          dataKey={""}
          addData={{}}
          multiline={selectOption.multi_text_flg === 1}
          rows={4}
          testId="form-options-edit-field-option_default_value"
          fieldKey="option_default_value"
        />
      ) : null}
      {selectOption["option_type"] == 0 ? (
        <PoField testId="form-options-edit-field-change_value_conf" fieldKey="change_value_conf">
          <PoLabel>入力値の編集</PoLabel>
          <PoSelect
            disabled={selectOption.option_default_value === ""}
            labelId="serch-input-label"
            id="serch-input"
            value={selectOption["change_value_conf"]}
            onChange={(e) => {
              setEelectOption({
                ...selectOption,
                change_value_conf: Number(e.target.value) as 0 | 1,
              });
            }}
            sx={{ height: 36, fontSize: 13, borderRadius: "var(--radius-sm, 6px)", textAlign: "end" }}
          >
            {LIST_POST["change_value_conf"].map((input, i) => (
              <MenuItem key={"input" + i} value={input.id} sx={{ fontSize: "14px", height: input.value === "" ? "14px" : "24px" }}>
                {input.value}
              </MenuItem>
            ))}
          </PoSelect>
          <PoHelper sx={{ textAlign: "right", fontSize: 11, color: "var(--color-sumi-muted, #9ca3af)" }}>
            ※デフォルト値が設定されているときのみ、入力値の編集を不可に変更できます。
          </PoHelper>
        </PoField>
      ) : null}
      <SerchTextField
        width="calc(100% - 10px)"
        key={"serchColumnBubunComment"}
        label={"説明"}
        helperText={""}
        value={selectOption["option_comment"]}
        setValue={(value) => {
          setEelectOption({
            ...selectOption,
            option_comment: value,
          });
        }}
        dataKey={""}
        addData={{}}
        testId="form-options-edit-field-option_comment"
        fieldKey="option_comment"
      />
      <PoField testId="form-options-edit-field-sns_send" fieldKey="sns_send">
        <PoLabel>チャットアプリ連携</PoLabel>
        <PoSelect
          labelId="serch-input-label"
          id="serch-input"
          value={selectOption["sns_send"]}
          onChange={(e) => {
            setEelectOption({
              ...selectOption,
              sns_send: Number(e.target.value) as 0 | 1,
            });
          }}
          sx={{ height: 36, fontSize: 13, borderRadius: "var(--radius-sm, 6px)", textAlign: "end" }}
        >
          {LIST_POST["sns_send"].map((input, i) => (
            <MenuItem key={"input" + i} value={input.id} sx={{ fontSize: "14px", height: input.value === "" ? "14px" : "24px" }}>
              {input.value}
            </MenuItem>
          ))}
        </PoSelect>
        <PoHelper sx={{ textAlign: "right", height: "25px", fontSize: 11, color: "var(--color-sumi-muted, #9ca3af)" }}>
          ※チャットアプリ連携した際にエントリー情報として連携するかどうか選択できます。
        </PoHelper>
      </PoField>
    </>
  );
}

interface FormOptionsEditModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  backSwCloseModal: () => void;
  editFormsStatus: {
    status:
      | "none"
      | "open"
      | "add"
      | "delete"
      | "success"
      | "loading"
      | "add_error"
      | "delete_error";
    message: string;
    editIDs: number[];
    action: null | 0 | 1;
    delete_option_names: string[];
    select_option: {
      option_name: string;
      outside_form_display: 0 | 1;
      sns_send: 0 | 1;
      required_optional: 0 | 1;
      option_type: 0 | 1 | 2 | 3 | 4;
      option_default_value: string;
      change_value_conf: 0 | 1;
      option_comment: string;
      tel_flg: 0 | 1;
      name_flg: 0 | 1;
      company_name_flg: 0 | 1;
      zip_code_flg: 0 | 1;
      address_flg: 0 | 1;
      space_flg: 0 | 1;
      mail_address_flg: 0 | 1;
      form_tel_flg: 0 | 1;
      multi_text_flg: 0 | 1;
      contract_number_flg: 0 | 1;
      half_width_number_flg: 0 | 1;
      option_select: string[];
    };
  };
  setEditFormsStatus: React.Dispatch<
    React.SetStateAction<{
      status:
        | "none"
        | "open"
        | "add"
        | "delete"
        | "success"
        | "loading"
        | "add_error"
        | "delete_error";
      message: string;
      editIDs: number[];
      delete_option_names: string[];
      action: null | 0 | 1;
      select_option: {
        option_name: string;
        outside_form_display: 0 | 1;
        sns_send: 0 | 1;
        required_optional: 0 | 1;
        option_type: 0 | 1 | 2 | 3 | 4;
        option_default_value: string;
        change_value_conf: 0 | 1;
        option_comment: string;
        tel_flg: 0 | 1;
        name_flg: 0 | 1;
        company_name_flg: 0 | 1;
        zip_code_flg: 0 | 1;
        address_flg: 0 | 1;
        space_flg: 0 | 1;
        mail_address_flg: 0 | 1;
        form_tel_flg: 0 | 1;
        multi_text_flg: 0 | 1;
        contract_number_flg: 0 | 1;
        half_width_number_flg: 0 | 1;
        option_select: string[];
      };
    }>
  >;
  getEditFormDeleteOptionNames: () => void;
  editFormOptionNames: string[];
  postEditFormOption: () => void;
  deleteEditFormOption: () => void;
  formType?: "entry_form" | "toss_up_form" | "outside_entry_form";
}

export function FormOptionsEditModal(props: FormOptionsEditModalProps) {
  const {
    onModal,
    swCloseModal,
    backSwCloseModal,
    editFormsStatus,
    setEditFormsStatus,
    getEditFormDeleteOptionNames,
    editFormOptionNames,
    postEditFormOption,
    deleteEditFormOption,
    formType,
  } = props;
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);

  // ★cmd-po_1221 R9: 成功トースト+自動クローズ処理を廃止＝結果モーダル統一。

  return editFormsStatus.status !== "loading" ? (
    <>
    <PoModalShell
      open={onModal && editFormsStatus.status !== "success"}
      title="質問一括追加・削除"
      onClose={swCloseModal}
      testidPrefix="form-options-edit"
      frameTestId="form-options-edit-modal"
      widthPx={520}
      bodySx={{ pt: "var(--sp-2, 8px)", gap: "var(--sp-3, 12px)" }}
      footer={
        editFormsStatus.status === "open" ? (
          <>
            <PoButton
              variant="primary"
              data-testid="form-options-edit-next"
              disabled={editFormsStatus.action === null}
              onClick={() => {
                if (editFormsStatus.action === 0) {
                  setEditFormsStatus({
                    ...editFormsStatus,
                    status: "add",
                  });
                } else if (editFormsStatus.action === 1) {
                  getEditFormDeleteOptionNames();
                }
              }}
            >
              次へ進む
            </PoButton>
            <PoButton
              variant="secondary"
              data-testid="form-options-edit-close"
              onClick={backSwCloseModal}
            >
              戻る
            </PoButton>
          </>
        ) : editFormsStatus.status === "add" ? (
          <>
            <PoButton
              variant="secondary"
              data-testid="form-options-edit-add-back"
              onClick={() =>
                setEditFormsStatus({
                  ...editFormsStatus,
                  status: "open",
                })
              }
            >
              戻る
            </PoButton>
            <PoButton
              variant="primary"
              data-testid="form-options-edit-add-submit"
              disabled={editFormsStatus.select_option.option_name === ""}
              onClick={() => {
                const sel = editFormsStatus.select_option;
                if (sel.option_default_value.includes("\n") && sel.multi_text_flg !== 1) {
                  setEditFormsStatus({
                    ...editFormsStatus,
                    status: "add_error",
                    message: `質問名「${sel.option_name}」：「デフォルト値」に改行が含まれています。改行は「複数行フラグ」設定時のみ使用できます。`,
                  });
                  return;
                }
                postEditFormOption();
              }}
            >
              追加
            </PoButton>
          </>
        ) : editFormsStatus.status === "add_error" ? (
          <PoButton
            variant="secondary"
            data-testid="form-options-edit-add-error-back"
            onClick={() =>
              setEditFormsStatus({
                ...editFormsStatus,
                status: "add",
              })
            }
          >
            戻る
          </PoButton>
        ) : editFormsStatus.status === "delete" ? (
          <>
            <PoButton
              variant="primary"
              data-testid="form-options-edit-delete-submit"
              disabled={editFormsStatus.delete_option_names.length === 0}
              onClick={deleteEditFormOption}
            >
              削除
            </PoButton>
            <PoButton
              variant="secondary"
              data-testid="form-options-edit-delete-back"
              onClick={() =>
                setEditFormsStatus({
                  ...editFormsStatus,
                  status: "open",
                })
              }
            >
              戻る
            </PoButton>
          </>
        ) : editFormsStatus.status === "delete_error" ? (
          <PoButton
            variant="secondary"
            data-testid="form-options-edit-delete-error-back"
            onClick={() =>
              setEditFormsStatus({
                ...editFormsStatus,
                status: "open",
              })
            }
          >
            戻る
          </PoButton>
        ) : null
      }
    >
      {editFormsStatus.status === "open" ? (
        <Box
          key="ContractAddModalBoxProject"
          sx={{ flexGrow: 1, maxHeight: !isSmartPhone ? undefined : "calc(70vh - 50px)", overflowY: !isSmartPhone ? undefined : "auto" }}
        >
          <Box
            key="shozai1"
          >
            <FormControl
              fullWidth
              sx={{
                marginTop: "10px",
                height: "45px",
                marginLeft: "5px",
                width: "calc(100% - 10px)",
              }}
            >
              <Select
                labelId="serch-input-label"
                id="serch-input-option"
                data-testid="form-options-edit-action-select"
                sx={{ height: 36, fontSize: 13, borderRadius: "var(--radius-sm, 6px)", textAlign: "end" }}
                onChange={(e) => {
                  const action = e.target.value as 0 | 1;
                  setEditFormsStatus({
                    ...editFormsStatus,
                    action,
                  });
                }}
              >
                <MenuItem value={0}>一括追加</MenuItem>
                <MenuItem value={1}>一括削除</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
      ) : editFormsStatus.status === "add" ? (
        <Box
          key="ContractAddModalBoxProject"
          sx={{ flexGrow: 1, maxHeight: !isSmartPhone ? undefined : "calc(70vh - 50px)", overflowY: !isSmartPhone ? undefined : "auto", display: "flex", flexDirection: "column", gap: "var(--sp-3)" }}
        >
          <Box
            component="span"
            data-testid="form-options-edit-note"
            sx={{ fontSize: "var(--fs-12, 12px)", color: "var(--color-sumi-light, #9ca3af)" }}
          >
            追加する質問の設定を入力してください。
          </Box>
          <Box
            key="shozai1"
            data-testid="form-options-edit-form"
            sx={{ display: "flex", flexDirection: "column", gap: "var(--sp-4, 16px)", padding: "var(--sp-4, 16px) var(--sp-5, 20px)" }}
          >
            <InputProductOption
              selectOption={editFormsStatus.select_option}
              setEelectOption={(select_option: any) => {
                setEditFormsStatus({
                  ...editFormsStatus,
                  select_option: select_option,
                });
              }}
              formType={formType}
            />
          </Box>
        </Box>
      ) : editFormsStatus.status === "add_error" ? (
        <Box data-testid="form-options-edit-status-error" className="info-alert -error">
          <Box component="span" className="ia-ic" sx={{ flexShrink: 0 }}>⚠</Box>
          {editFormsStatus.message}
        </Box>
      ) : editFormsStatus.status === "delete" ? (
        <Box
          key="ContractAddModalBoxContract"
          sx={{ flexGrow: 1, maxHeight: !isSmartPhone ? undefined : "calc(70vh - 50px)", overflowY: !isSmartPhone ? undefined : "auto" }}
        >
          <Box
            key="shozai1"
          >
            {editFormOptionNames.map((optionName, i) => {
              return (
                <Box
                  key={"deleteOptionName_" + i}
                  sx={{ marginRight: "25px" }}
                >
                  <Checkbox
                    sx={{
                      "& .MuiSvgIcon-root": { fontSize: 16 },
                      marginTop: "-5px",
                    }}
                    checked={editFormsStatus.delete_option_names.includes(
                      optionName,
                    )}
                    onClick={() => {
                      let delete_option_names =
                        editFormsStatus.delete_option_names.concat();
                      if (
                        editFormsStatus.delete_option_names.includes(
                          optionName,
                        )
                      ) {
                        delete_option_names = delete_option_names.filter(
                          (option_name) => option_name !== optionName,
                        );
                      } else {
                        delete_option_names.push(optionName);
                      }
                      setEditFormsStatus({
                        ...editFormsStatus,
                        delete_option_names,
                      });
                    }}
                  />
                  {optionName}
                </Box>
              );
            })}
          </Box>
        </Box>
      ) : editFormsStatus.status === "delete_error" ? (
        <Box data-testid="form-options-edit-status-error" className="info-alert -error">
          <Box component="span" className="ia-ic" sx={{ flexShrink: 0 }}>⚠</Box>
          {editFormsStatus.message}
        </Box>
      ) : null}
    </PoModalShell>
    {/* ★cmd-po_1221 R9: 編集成功=結果モーダル（トースト→統一・閉じるで手動クローズ） */}
    <DataAddModalResult
      onModal={onModal && editFormsStatus.status === "success"}
      onDataAddModalResult="success"
      successMessage="変更を保存しました。"
      swCloseModal={swCloseModal}
      addModalTitle="編集"
    />
    </>
  ) : null;
}
